

import { useEffect } from 'react';


const useMount = (
  callback: (...rest: unknown[]) => void,
  deps: React.DependencyList = []
) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => callback(), deps);
}


export default useMount;
